 
  export const TableName = {
   Products :"Products",
   Brands : "Brands",
   ProductTypes : "ProductTypes",
   ProductTags : "ProductTags",
   Suppliers :"Suppliers",
   SalesTaxes : "SalesTaxes",//Same Call on Sales Tax Groups
   SellAttributes :  "SellAttributes",
   SellAttributeGroups :  "SellAttributeGroups",
};

//  Promotions : "Promotions", //Duplicate on VEND
  //  Pricebooks : "Pricebooks", //Duplicate on VEND